import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Register',
    data () {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            user_purchase:false,
            terms:true,
            disable_btn: false,
            loading:false,
            action_loading:false,
            data_proccessing_message:"",
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter
     },
    methods: {
        reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
        },
        
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },


        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        getCities(state) {
            service.getCities(this, state).then(function(data) {
                this.cities = data.body;
            })
        },
        reg(){
            this.disable_btn = true;
            this.user.agree = true; ///change 
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email,
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password
            }

            let navi = this.$router;
           if(credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null &&
            credentials.user_email != null && credentials.user_password != null) {
                if(this.terms) {
                    this.activate_processing();
                    service.regUser(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            this.data_proccessing_message = "Account Created";
                            //log user in
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            }
                            service.loginUser(this, credentials).then(response => {
                                if(response.body.status == 200) {
                                    let data = response.body.data;
                                    localStorage.setItem("sp_user", data.user_name); 
                                    localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                                    localStorage.setItem("sp_token_key", data.user_token_key); 
                                    if(this.user_purchase){
                                        navi.push("/getstarted");
                                    }
                                    else{
                                        navi.push('/account');
                                    }  
                                    //  navi.push('account');
                                   // location.replace('/')
                                }
                            }).catch((err) => {
                                if(err.status == 404) {
                                    this.data_proccessing_message = "invalid login credentials"; 
                                    this.deactivate_processing();
                                }
                            })
                        }else if(data.body.status == 409) {
                            this.data_proccessing_message = "You already have a Sellpoint Account"; 
                            ////Info-+loging-prompt
                            this.deactivate_processing();
                        }
                    })
                }else {
                    this.data_proccessing_message = 'Please agree to Terms';
                    this.disable_btn = false;
                }
        }else {
            this.data_proccessing_message = 'Kindly fill all fields';
            this.disable_btn = false;
        }
    }
    },
    created: function(){
       
    }
}


// WEBPACK FOOTER //
// ./src/pages/Register/script.js